"use client";

import { useEffect, useState } from "react";
import { APP_HOST, WEBSITE_ORIGIN } from "@/lib/domain-routing";

/** Browser auth pages link back to the website; native shells keep their own welcome. */
export function useWebsiteHomeHref(): string {
  const [href, setHref] = useState("/");
  useEffect(() => {
    const capacitor = (window as unknown as {Capacitor?: {isNativePlatform?: () => boolean}}).Capacitor;
    if (window.location.hostname === APP_HOST && !capacitor?.isNativePlatform?.()) {
      setHref(WEBSITE_ORIGIN);
    }
  }, []);
  return href;
}
